const facilities = [
  {
    name: "USPS Venice",
    address: "333 W Venice Ave, Venice, FL 34285",
    hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
    notes: "Primary passport acceptance facility serving Venice residents. Located in the heart of historic downtown Venice near Venice Avenue. Passport services by appointment only. Photo services available on-site. Serves Venice, South Venice, Nokomis, and surrounding Sarasota County communities.",
  },
  {
    name: "USPS Sarasota Main",
    address: "1669 Ringling Blvd, Sarasota, FL 34236",
    hours: "Mon–Fri: 9:00 AM – 4:00 PM",
    notes: "Full-service passport acceptance facility approximately 30–35 minutes north of Venice via US-41 (Tamiami Trail) or I-75. By appointment required. Photo services available. Serves Sarasota, Venice, Siesta Key, and broader Sarasota County.",
  },
  {
    name: "USPS North Port",
    address: "5950 Sam Shapiro Way, North Port, FL 34287",
    hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
    notes: "Approximately 15–20 minutes east of Venice via US-41 or Sumter Boulevard. Passport services by appointment. On-site photo services available. Serves North Port, Warm Mineral Springs, and eastern Sarasota County communities.",
  },
  {
    name: "USPS Englewood",
    address: "1368 Beach Rd, Englewood, FL 34223",
    hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
    notes: "Approximately 20–25 minutes south of Venice via US-41 (Tamiami Trail) or River Road. Passport services by appointment. Photo services available on-site. Serves Englewood, Manasota Key, Rotonda West, and southern Sarasota/Charlotte County communities.",
  },
  {
    name: "Sarasota County Clerk — Downtown Sarasota",
    address: "2000 Main St, Sarasota, FL 34237",
    hours: "Mon–Fri: 8:00 AM – 5:00 PM",
    notes: "County clerk facility approximately 30–35 minutes north of Venice via US-41 or I-75. Offers passport application acceptance services with notarization and document verification. Appointment strongly recommended. Additional Sarasota County Clerk locations may be available throughout the county.",
  },
];

export default function VeniceAcceptanceFacilitiesSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Where to Apply
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Venice, FL
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            These are the government-designated locations where you can submit your passport application with proper execution. Call ahead — appointments are often required.
          </p>
        </div>

        <div className="space-y-4">
          {facilities.map((f, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all"
            >
              <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6">
                <div className="shrink-0">
                  <div className="w-12 h-12 rounded-lg bg-[#1A365D] flex items-center justify-center">
                    <i className="ri-building-line text-[#F6C344] text-xl"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="font-serif text-base font-bold text-[#1A365D] mb-1">
                    {f.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-2">
                    <i className="ri-map-pin-line text-[#B22222] mr-1"></i>
                    {f.address}
                  </p>
                  <p className="text-gray-500 text-xs mb-3">
                    <i className="ri-time-line mr-1"></i>
                    {f.hours}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed">{f.notes}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#FFF8E7] border-l-4 border-[#F6C344] rounded-r-lg p-6 flex items-start gap-4">
          <i className="ri-information-line text-[#F6C344] text-xl shrink-0 mt-0.5"></i>
          <div>
            <h4 className="font-semibold text-[#1A365D] mb-1">Important Reminder</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Acceptance facilities do <strong>not</strong> expedite your passport. They only witness your signature and forward your application to the State Department. For emergency processing, you need a registered courier like Fast Passport Center to hand-carry your application through expedited channels.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}